import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_URL } from "../../config";

// RTK Query client for the "Send Login" Action form (thread #1379). Two
// endpoints on the BFF, gated server-side to the "Send Login" TABC row (the
// controller default-denies with 403 until the row exists in Airtable + is
// mirrored). The per-position "Send Login Limited to Positions" restriction is
// enforced on the server for BOTH endpoints, so the search only ever returns
// employees the caller is allowed to send to, and the send re-verifies.
export const sendLoginApi = createApi({
  reducerPath: "sendLoginApi",
  // No cross-session caching: eligibility can change and the results contain
  // the employee's phone/email (freshness over reuse on a send-form).
  keepUnusedDataFor: 0,
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // Active employees the caller may send logins to. q (name or Employee ID)
    // is optional; the server LIMITs to 50 and sorts by name.
    sendLoginSearch: builder.query({
      query: (q) => ({
        url: `/send-login/portal/search?q=${encodeURIComponent(q ?? "")}`,
        method: "GET",
      }),
    }),
    // One-click send: texts + emails the target employee their portal login.
    // Body: { employeeRecId }. Returns per-channel results in data.sms / data.email.
    sendLoginSend: builder.mutation({
      query: (body) => ({
        url: "/send-login/portal/send",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useLazySendLoginSearchQuery,
  useSendLoginSendMutation,
} = sendLoginApi;
